export const PopupType = {
  PAYMENT_REMIND_POPUP: 'PAYMENT_REMIND_POPUP',
};

export const PlatformType = {
  WEB: 'WEB',
  WEB_MOBILE: 'WEB_MOBILE',
  APP: 'APP',
};
